/**
 * description: 内容管理
 * dateTime: 2024/8/22-上午10:19
 * author: ZhangJun 1580043700@qq.com
 */

import request, {METHODS} from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

/**
 * 会员信息列表
 * @param options
 */
export const queryMemberInfoListByPage = (options: any) => {
    return request(`${UrlConfig.member.queryMemberInfoListByPage}`, {
        method: METHODS.POST,
        ...options,
    })
}
/**
 * 获取电话
 */
export const viewPhoneClueInfo = (clueId, raw = false) => {
    return request(`${UrlConfig.PlusCrmWeb.ViewPhone}/${clueId}`, {
      method: METHODS.GET,
      raw,
    })
  }
/**
 * 保存或更新会员信息
 * @param data
 */
export const saveOrUpdateMemberInfo = (data: any) => {
    return request(`${UrlConfig.member.saveOrUpdateMemberInfo}`, {
        method: METHODS.PUT,
        data,
    })
}

/**
 * 根据id删除会员信息
 * @param params
 */
export const deleteMemberInfo = (params: any) => {
    return request(`${UrlConfig.member.deleteMemberInfo}`, {
        method: METHODS.DELETE,
        params,
    })
}

/**
 * 查询会员信息详情
 * @param params
 */
export const queryMemberInfo = (params: any) => {
    return request(`${UrlConfig.member.queryMemberInfo}`, {
        method: METHODS.POST,
        params,
    })
}

/**
 * 分页查询成长值、积分流水明细列表
 * @param options
 */
export const queryMemberEventDetailListByPage = (options: any) => {
    return request(`${UrlConfig.member.queryMemberEventDetailListByPage}`, {
        method: METHODS.POST,
        ...options,
    })
}

/**
 * 保存或更新成长值、积分流水明细
 * @param data
 */
export const saveOrUpdateMemberEventDetail = (data: any) => {
    return request(`${UrlConfig.member.saveOrUpdateMemberEventDetail}`, {
        method: METHODS.PUT,
        data,
    })
}

/**
 * 保存或更新会员等级
 * @param data
 */
export const saveOrUpdateMemberLevel = (data: any) => {
    return request(`${UrlConfig.member.saveOrUpdateMemberLevel}`, {
        method: METHODS.PUT,
        data,
    })
}

/**
 * 查询会员等级列表
 * @param data
 */
export const queryMemberLevelList = (data: any) => {
    return request(`${UrlConfig.member.queryMemberLevelList}`, {
        method: METHODS.POST,
        data,
    })
}
/**
 * 分页查询会员等级列表
 * @param options
 */
export const queryMemberLevelListByPage = (options: any) => {
    return request(`${UrlConfig.member.queryMemberLevelListByPage}`, {
        method: METHODS.POST,
        ...options,
    })
}

/**
 * 根据id删除会员等级
 * @param params
 */
export const deleteMemberLevel = (params: any) => {
    return request(`${UrlConfig.member.deleteMemberLevel}`, {
        method: METHODS.DELETE,
        params,
    })
}

/**
 * 保存或更新会员事件
 * @param data
 */
export const saveOrUpdateMemberEvent = (data: any) => {
    return request(`${UrlConfig.member.saveOrUpdateMemberEvent}`, {
        method: METHODS.PUT,
        data,
    })
}
/**
 * 保存或更新积分配置、成长值配置
 * @param data
 */
export const saveOrUpdateMemberConfiguration = (data: any) => {
    return request(`${UrlConfig.member.saveOrUpdateMemberConfiguration}`, {
        method: METHODS.PUT,
        data,
    })
}
/**
 * 批量保存或更新积分配置、成长值配置
 * @param data
 */
export const saveOrUpdateBatchMemberConfiguration = (data: any) => {
    return request(`${UrlConfig.member.saveOrUpdateBatchMemberConfiguration}`, {
        method: METHODS.PUT,
        data,
    })
}

/**
 * 根据会员事件id更新状态
 * @param params id & state
 */
export const updateState = (params: any) => {
    return request(`${UrlConfig.member.updateState}`, {
        method: METHODS.POST,
        params,
    })
}
/**
 * 查询会员事件列表分页
 * @param data
 */
export const queryMemberEventList = (data: any) => {
    return request(`${UrlConfig.member.queryMemberEventList}`, {
        method: METHODS.POST,
        data,
    })
}
/**
 * 查询会员事件列表分页
 * @param options
 */
export const queryMemberEventListByPage = (options: any) => {
    return request(`${UrlConfig.member.queryMemberEventListByPage}`, {
        method: METHODS.POST,
        ...options,
    })
}

/**
 * 根据会员事件id删除会员事件
 * @param params
 */
export const deleteMemberEvent = (params: any) => {
    return request(`${UrlConfig.member.deleteMemberEvent}`, {
        method: METHODS.DELETE,
        params,
    })
}

/**
 * 添加/根据分类id更新会员权益分类
 * @param data
 */
export const saveOrUpdateMemberEquityCategory = (data: any) => {
    return request(`${UrlConfig.member.saveOrUpdateMemberEquityCategory}`, {
        method: METHODS.PUT,
        data,
    })
}
/**
 * 根据id查询会员权益分类详情
 * @param params
 */
export const queryMemberEquityCategoryInfo = (params: any) => {
    return request(`${UrlConfig.member.queryMemberEquityCategoryInfo}`, {
        method: METHODS.POST,
        params,
    })
}
/**
 * 查询积分配置、成长值配置列表
 * @param data
 */
export const queryMemberConfigurationList = (data: any) => {
    return request(`${UrlConfig.member.queryMemberConfigurationList}`, {
        method: METHODS.POST,
        data,
    })
}

/**
 * 根据分类id删除会员权益分类
 * @param params
 */
export const deleteMemberEquityCategory = (params: any) => {
    return request(`${UrlConfig.member.deleteMemberEquityCategory}`, {
        method: METHODS.DELETE,
        params,
    })
}

/**
 * 查询会员权益分类列表分页
 * @param options
 */
export const queryMemberEquityCategoryListByPage = (options: any) => {
    return request(`${UrlConfig.member.queryMemberEquityCategoryListByPage}`, {
        method: METHODS.POST,
        ...options,
    })
}
/**
 * 查询会员权益分类列表
 * @param data
 */
export const queryMemberEquityCategoryList = (data: any) => {
    return request(`${UrlConfig.member.queryMemberEquityCategoryList}`, {
        method: METHODS.POST,
        data,
    })
}

/**
 * 查询会员权益列表
 * @param options
 */
export const queryMemberEquityListByPage = (options: any) => {
    return request(`${UrlConfig.member.queryMemberEquityListByPage}`, {
        method: METHODS.POST,
        ...options,
    })
}

/**
 * 添加/根据分类id更新会员权益
 * @param data
 */
export const saveOrUpdateMemberEquity = (data: any) => {
    return request(`${UrlConfig.member.saveOrUpdateMemberEquity}`, {
        method: METHODS.PUT,
        data,
    })
}

/**
 * 根据会员权益id更新状态
 * @param params
 */
export const updateStateMemberEquity = (params: any) => {
    return request(`${UrlConfig.member.updateStateMemberEquity}`, {
        method: METHODS.POST,
        params,
    })
}

/**
 * 根据分类id删除会员权益
 * @param params
 */
export const deleteMemberEquity = (params: any) => {
    return request(`${UrlConfig.member.deleteMemberEquity}`, {
        method: METHODS.DELETE,
        params,
    })
}

/**
 * 分页查询会员任务配置列表
 * @param options
 */
export const queryMemberTaskListByPage = (options: any) => {
    return request(`${UrlConfig.member.queryMemberTaskListByPage}`, {
        method: METHODS.POST,
        ...options,
    })
}

/**
 * 根据会员任务配置id删除会员任务配置
 * @param params
 */
export const deleteMemberTask = (params: any) => {
    return request(`${UrlConfig.member.deleteMemberTask}`, {
        method: METHODS.DELETE,
        params,
    })
}

/**
 * 根据会员权益id更新状态
 * @param params
 */
export const memberTaskUpdateState = (params: any) => {
    return request(`${UrlConfig.member.memberTaskUpdateState}`, {
        method: METHODS.POST,
        params,
    })
}

/**
 * 保存或更新会员任务
 * @param data
 */
export const saveOrUpdateTask = (data: any) => {
    return request(`${UrlConfig.member.saveOrUpdateTask}`, {
        method: METHODS.PUT,
        data,
    })
}

/**
 * 获取解密值
 */
export const getDecodeValue = encodeValue => {
    return request(UrlConfig.Crm.GetPhoneDecodeValue, {
      method: METHODS.GET,
      params: {
        encodeValue: decodeURIComponent(encodeValue),
      },
      raw: true
    })
  }

/**
 * 查看电话
 */
export const operatePhoneLog = (id, operateType, sysItem, param1) => {
    return request(UrlConfig.Crm.AddOperatePhoneLog, {
      method: METHODS.POST,
      data: {
        itemId: id,
        operateType: operateType, //"SEE_PHONE_NUMBER",
        sysItem: sysItem, //"WORKER_ORDER", "工单列表"   "ISSUE", "问题列表"
        param1: param1, //签约电话，联系电话
      },
      raw: true
    })
  }

  /**
 * 获取电话
 */
export const viewPhone = async (option: API.Options) => {
    const { id } = option.params;
    return await request(`${UrlConfig.Clue.ViewPhone}/${id}`, { method: METHODS.GET })
  }
/**
 * 分页查询渠道与角色关系数据
 * @param options
 */
export const getMemberChannelRolePage = (options: any) => {
    return request(`${UrlConfig.member.queryMemberChannelRolePage}`, {
        method: METHODS.POST,
        ...options,
    })
}
// 获取角色列表
export const getRoleListFn = (data:any) => {
    return request(UrlConfig.Caas.GetRoleList, {
        method: METHODS.POST,
        data,
    })
}
/**
 * 新增-渠道与角色关系数据
 * @param data
 */
export const addChannelRoleRef = (data: any) => {
    return request(`${UrlConfig.member.addChannelRoleRef}`, {
        method: METHODS.POST,
        data,
    })
}
/**
 * 编辑-渠道与角色关系数据
 * @param data
 */
export const editChannelRoleRef = (data: any) => {
    return request(`${UrlConfig.member.editChannelRoleRef}`, {
        method: METHODS.POST,
        data,
    })
}
/**
 * 根据id删除-渠道与角色关系数据
 * @param params
 */
export const delChannelRoleRef = (params: any) => {
    return request(`${UrlConfig.member.delChannelRoleRef}/${params?.id||""}`, {
        method: METHODS.DELETE,
        params,
    })
}

export const channelClueUpdate = (data: any) => {
    return request(`${UrlConfig.member.channelClueUpdate}`, {
        method: METHODS.POST,
        data,
    })
}

export const busFlowList = data => {
    return request(`${UrlConfig.PlusCrmWeb.busFlowList}`, {
      method: METHODS.POST,
      data,
    });
};
